import MainModal from '@/common/components/base/modal/Modal.tsx';
import TitleDescription from '@/common/components/base/typography/TitleDescription.tsx';
import Typography from '@/common/components/base/typography/Typography.tsx';
import { LocationDetailCardModalType } from '@/common/components/DetailCard/items/locationDetailCardItem/LocationDetailCardItem.type.ts';
import { Box } from 'styled-system/jsx';

export default (props: LocationDetailCardModalType) => {
  const { closeModal, open } = props;
  return (
    <MainModal open={open} closeModal={closeModal}>
      <LocationModal {...props} />
    </MainModal>
  );
};

const LocationModal = ({ title, address }: LocationDetailCardModalType) => {
  return (
    <Box>
      <TitleDescription textStyle="h2" mb="20px">
        {title}
      </TitleDescription>
      <Box
        mb="20px"
        mx="10px"
        p="15px"
        backgroundColor="white"
        borderRadius="8px"
        shadow="cardShadow"
      >
        <Box maxWidth={112} textAlign="left">
          <Typography textStyle="b2">{address}</Typography>
        </Box>
      </Box>
    </Box>
  );
};
